<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.layout-breadcrumb {
  padding: 10px 15px 0;
  display: inline-block;
}
.layout-content {
  min-height: 200px;
  margin: 15px;
  overflow: auto;
  background: #fff;
  border-radius: 4px;
  height: calc(100vh - 90px);
}
.layout-content-main {
  padding: 10px;
}
.layout-copy {
  text-align: center;
  padding: 10px 0 20px;
  color: #9ea7b4;
}
.layout-menu-left {
  background: #464c5b;
}
.layout-header {
  height: 60px;
  background: #fff;
}
.layout-logo-left {
  width: 90%;
  height: 60px;
  line-height: 60px;
  font-size: 28px;
  text-align: center;
  color: #fff;
  /*  background: #5b6270;
        border-radius: 3px;
        margin: 15px auto;*/
}
.layout-ceiling-main a {
  color: #9ba7b5;
}
.layout-hide-text .layout-text {
  display: none;
}
.ivu-col {
  transition: width 0.2s ease-in-out;
}
.ivu-row-flex {
  height: 100%;
}
.userinfo {
  display: inline-block;
  float: right;
}
.userinfo .ivu-dropdown {
  margin-top: 50px;
}
.ivu-dropdown {
    margin-top: 22px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
   
}
.ivu-menu-submenu-title {
  padding: 14px;
}

.head-img {
  width: 100%;
  height: 60px;
  line-height: 60px;
  float: right;
  margin-top: -50px;
}
.head-img img {
  border-radius: 20px;
  margin: 10px 0px 10px 10px;
  width: 40px;
  height: 40px;
  float: right;
}
.layout-content-main li {
  display: none;
}
.layout-content-main .on {
  display: block;
}
.iconfont{
color: #fff
}
</style>
<template>
    <div class="layout" :class="{'layout-hide-text': spanLeft < 3}">
        <Row type="flex">
            <i-col :span="spanLeft" class="layout-menu-left">
                <Menu :mode="modeType" theme="dark" width="auto" :active-name="this.$route.path" :open-names="openNames" @on-select="menuSelect" accordion>
                     <div class="layout-logo-left">
                         <span class="layout-text">{{site_title}}</span>
                     </div>
                   <template v-for="(item,index) in menudata" v-if="spanLeft == 3  && menudata.length>0">  
                        <Submenu :name="item.name" :key='index'>
                            <template slot="title">

                                <i :class="'iconfont '+item.icon"  :size="iconSize"></i>
                                <span class="layout-text" >{{item.name}}</span>
                            </template>
                            <template v-for="(child,childIndex) in item.submenu"> 
                                  <Submenu v-if="child.submenu" :key="childIndex" :name='stename(child)'>
                            <template slot="title">
                                    <span class="layout-text" >{{child.name}}</span>
                            </template>
                            <template v-for="(Grandson,GrandIndex) in child.submenu">
                                    <Menu-item :name='stename(Grandson)' :key="GrandIndex">{{Grandson.name}}</Menu-item>
                            </template>
                                </Submenu>  
                                <Menu-item v-else :name='stename(child)' :key="childIndex">{{child.name}}</Menu-item>
                            </template>
                        </Submenu>
                        <!-- <template  v-if="item.leaf&&item.children.length>0">
                            <Menu-item :name="item.children[0].path">
                                 <Icon :type="item.iconCls" :size="iconSize"></Icon>
                                <span class="layout-text" >{{item.children[0].name}}</span>
                            </Menu-item>
                        </template>   -->
                   </template>
                   <template v-for="(item,index) in menudata" v-if="spanLeft < 3">
                      <Dropdown  placement="right-start" class="_dropdownList" @transfer="true" @on-click="dropDown" :key="index">
                        <a href="javascript:void(0)">
                         <i :class="'iconfont '+item.icon"  :size="iconSize"></i>
                        </a>
                        <DropdownMenu slot="list">
                          <template v-for='(value,index) in item.submenu'>
                           
                             <Dropdown placement="right-start" v-if="value.submenu&&value.submenu.length>0" :key="index">
                                <DropdownItem :name="stename(value)">
                                   {{value.name}}
                                    <Icon type="ios-arrow-right"></Icon>
                                </DropdownItem>
                                <DropdownMenu slot="list">
                                    <template v-for="(data,index) in value.submenu">
                                       <DropdownItem :name="stename(data)" :key="index">{{data.name}}</DropdownItem>
                                    </template>
                                </DropdownMenu>
                            </Dropdown>
                             <DropdownItem :name='stename(value)' v-else :key="index">{{value.name}}</DropdownItem>
                          </template>
                        </DropdownMenu>
                    </Dropdown>
                       <!-- <Dropdown placement="right-start" class="_dropdownList" @transfer="true" @on-click="dropDown">
                            <a href="javascript:void(0)">
                                <Icon type="ios-home" class="_iconCls ivu-col-span-1" :size="iconSize"></Icon>
                            </a>
                            <DropdownMenu slot="list">
                                 <DropdownItem  v-if="!item.name" :name="item.submenu[0].path">{{item.submenu[0].name}}</DropdownItem>  
                            </DropdownMenu>    
                        </Dropdown> -->
                   </template>
                </Menu>
            </i-col>
            <i-col :span="spanRight">
                <div class="layout-header">
                    <i-button type="text" @click="toggleClick">
                        <Icon type="navicon" size="32"></Icon>
                    </i-button>
                    <div class="layout-breadcrumb">
                        <e-breadcrumb :path="this.$route.path"></e-breadcrumb>
                    </div>
                    <div class="userinfo">
                      <Dropdown placement="bottom-end">
                        <span class="head-img">
                            {{curUserName}}
                            <!-- <img src="../assets/user.jpg"> -->
                        </span>
                        <Dropdown-menu slot="list">
                            <!-- <Dropdown-item @click.native="modifyPassWord()">修改密码</Dropdown-item> -->
                            <Dropdown-item  @click.native="logout()" divided>退出</Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                    </div>
                </div>
           
                <div class="layout-content">
                    <div class="layout-content-main">

                        <router-view></router-view>
  

                     </div>
                </div>
            </i-col>
        </Row>

          <Modal v-model="modal1" title="修改密码" @on-ok.prevent="comfirmModifyPS"  @on-cancel="cancel" >
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
                <Form-item label="原密码" prop="oldPassword">
                    <i-input v-model="formValidate.oldPassword" placeholder="请输入原始密码"></i-input>
                </Form-item>
                <Form-item label="新密码" prop="newPassword">
                    <i-input v-model="formValidate.newPassword" placeholder="请输入新密码"></i-input>
                </Form-item>
                 <Form-item label="确认新密码" prop="resetPassword">
                    <i-input v-model="formValidate.resetPassword" placeholder="请再次输入新密码"></i-input>
                </Form-item>
            </Form>
        </Modal>
    </div>
    <!-- 修改密码 模态框 -->
  
<!-- 修改密码 模态框 -->
</template>

<script>
import { rolelist } from "../api/roleapi";

import { privileges } from "../api/privilegesapi";
import { menulist, privilegescheck } from "../api/api";
import { mapGetters, mapState } from "vuex";
import ebreadcrumb from "./tool/ebreadcrumb";
import addRoutes from "../constant/addroutes.js";
import { paymethodindex } from "../api/paymethodapi";
import { settingindex } from "../api/paymethodapi";
import { menuindex } from '../api/menuapi'
// import menudata from "../leftMenu";
export default {
  data() {
    return {
      openNames: [this.$route.matched[0].name],
      curUserName: sessionStorage.getItem("user").replace(/\"/g, ""),
      modeType: "vertical",
      spanLeft: 3,
      spanRight: 21,
      logoIsDisplay: false,
      loading: true,
      modal1: false,
      site_title:"",
      // menudata: menudata,
      // // menudata:[],
      formValidate: {
        oldPassword: "",
        newPassword: "",
        resetPassword: ""
      },
      ruleValidate: {
        oldPassword: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        resetPassword: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ]
      }
    };
  },
  components: {
    "e-breadcrumb": ebreadcrumb
  },
  computed: {
    ...mapState({
      menudata: state => state.menudata
    }),
    ...mapGetters([
      "GETmenudata"
      // ...
    ]),
    getincon(icon) {
        return 'iconfont '+icon
    },
    iconSize() {
      return this.spanLeft === 5 ? 14 : 24;
    },
    logoSize() {
      if (this.spanLeft !== 3) {
        this.logoIsDisplay = true;
        return 50;
      } else {
        this.logoIsDisplay = false;
        return 0;
      }
    }
  },
  methods: {
    toggleClick() {
      if (this.spanLeft === 3) {
        this.spanLeft = 1;
        this.spanRight = 23;
      } else {
        this.spanLeft = 3;
        this.spanRight = 21;
      }
    },
    modifyPassWord() {
      this.modal1 = true;
    },
    logout() {
      this.$router.push("/login");
    },
    comfirmModifyPS() {
      return false;
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.modal1 = false;
          //         this.loading = false;
          this.$Message.success("提交成功!");
        } else {
          this.$Message.error("表单验证失败!");
          return false;
        }
      });
      // this.$Message.info('点击了确定');
    },
    rolelist() {
      let para = {};
      rolelist(para).then(res => {
        var Data = res.data;
        let roledata = Data.data.data;
        let rolelist = [];
        roledata.forEach(value => {
          rolelist.push({
            id: value.id,
            name: value.name
          });
        });
        this.$store.commit("GETROLELIST", rolelist);
      });
    },
    privileges() {
      let para = {
        page: 1,
        pagesize: 100000
      };
      privileges(para).then(res => {
        var Data = res.data;
        let privileges = Data.data.data;
        let privilegeslist = [];
        privileges.forEach(value => {
          privilegeslist.push({
            id: value.id,
            name: value.name
          });
        });
        this.$store.commit("GETprivileges", privilegeslist);
      });
    },
    getpaycode() {
      var par = {};
      paymethodindex(par).then(res => {
        var Data = res.data;
        let paycode = Data.data.data;
        let paycodelist = [];
        paycode.forEach(value => {
          paycodelist.push({
            id: value.code,
            name: value.name
          });
        });
        this.$store.commit("GETpaycode", paycodelist);
      });
    },
    loadStyle(url) {
      var link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = url;
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(link);
    },
    settingindex() {
      let par = {};
      settingindex(par).then(res => {
        var data = res.data;
        if (data.code == 1) {
          var data = data.data;
          document.title = data.site_title;
          this.site_title=data.site_title;
          this.loadStyle(data.iconfont_css);
          this.$store.commit("gerseet", data);
        }
      });
    },

    cancel() {
      this.modal1 = false;
      this.$Message.info("点击了取消");
    },
    setmenu() {
      this.$router.addRoutes(addRoutes);
    },
    stename(data) {
      return data.id + "," + data.link;
    },
    privilegescheck(check) {
      privilegescheck({ id: check[0] }).then(res => {
        var data = res.data;
        if (data.code == 1) {
          var Data = data.data;
          var data = {
            privilegescheck: Data
          };
          this.$store.commit("SIGN_Login", data);
          this.$router.push({ path: check[1] });
        }
      });
    },
    menuSelect(name) {
      var data = name.split(",");
      var state = {
        activiId: data[0]
      };
      this.$store.commit("SIGN_Login", state);
      this.privilegescheck(data);
    },
    dropDown(name) {
          var data = name.split(",");
      var state = {
        activiId: data[0]
      };
      this.$store.commit("SIGN_Login", state);
      this.privilegescheck(data);
    },
    getmenulist() {
      var par = {};
      menuindex(par).then(res => {
        var data = res.data;
        if (data.code == 1) {
           var Data = data.data;
          var state = {
            menulist: Data
          };
          this.$store.commit("SIGN_Login", state);
        }
      });
    }
    // //刷新页面后 重置vuex
    // refresh(){

    // }
  },
  mounted() {
    console.log(this.menudata);
    console.log(this.GETmenudata);
    console.log(this.menudata);
    this.rolelist();
    this.privileges();
    this.getmenulist();
    this.getpaycode();
    this.settingindex();
  }
};
</script>
<style scoped>
.ivu-select-dropdown .ivu-dropdown {
  margin: 0px 12px 0px 0px;
}
._dropdownList {
  /*  width: 100%;
    text-align: center; */
}
._iconCls {
  width: 56px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue